class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    // this.cachedResults = {};
    // this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    // this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    // this.isOpen = false;
    // this.abortController = new AbortController();
    // this.searchTerm = '';
    //
    // this.setupEventListeners();
  }

}

customElements.define('predictive-search', PredictiveSearch);
